module.exports = __webpack_public_path__ + "img/uid_tip_ru.bdd2c2c.png";